export const SHOW_REGIONS_REGION_TYPE = 'region'
export const SHOW_REGIONS_CITY_TYPE = 'city'
export const GENDER = 'gender'
export const MALE = 'male'
export const FEMALE = 'female'
export const AGE_MIN = 'age_min'
export const AGE_MAX = 'age_max'
